export default function(props, state, options) {
    let properties = Object.assign({}, props, options);
    let trueLabel = properties.label ? properties.label : "";
    if (properties.skipLabel) trueLabel = null;
    let isHintDiscrete = properties.discreteHint !== false; //discrete by default!
    let containerClass = properties.extraClasses || "";
    containerClass = "tq-form-element " + containerClass;
    if (properties.animated) {
        containerClass += " tq-animated";
    }
    let valueContainerClass = properties.valueContainerClass || "";
    let isInputElement = properties.isInputElement !== false;
    if (isInputElement) {
        valueContainerClass = "tq-input-container " + valueContainerClass;
    }
    if (properties.valueAlignment) {
        valueContainerClass += " tq-text-" + properties.valueAlignment;
    }
    if (properties.fontStyles) {
        for (let fontStyle of properties.fontStyles) {
            valueContainerClass += " tq-" + fontStyle;
        }
    }

    return {
        label: trueLabel,
        hasFeedback: properties.hasFeedback,
        unitsDisabled: properties.unitsDisabled,
        containerClass: containerClass,
        valueContainerClass: valueContainerClass,
        vertical: properties.vertical,
        required: properties.required,
        disabled: properties.disabled,
        hint: isHintDiscrete ? properties.hint : null,
        tooltipMaxWidth: properties.tooltipMaxWidth,
        tooltipContainerClasses: properties.tooltipContainerClasses,
        valueWidth: properties.valueWidth,
        labelWidth: properties.labelWidth,
        valid: state.valid,
        showValidityIcon: properties.showValidityIcon && !!state.value,
        dataTqId: properties.dataTqId,
        labelAlignment: properties.labelAlignment,
        isInMultiInput: properties.isInMultiInput,
        extraClasses: properties.extraClasses,
        onClickLabelButton: properties.onClickLabelButton,
        labelButton: properties.labelButton
    };
}
